import {addToListMap} from "../../utils/collections";
import {isEmpty} from "../../utils/objects";
import {chain} from "../../utils/fs";

export const loadingSequence = (list) => {
    list = validate(list);

    let pendings = list.slice(0);
    let waitings = {};
    let ret = [];

    const getRequired = (item) => {
        if (!item.requires) {
            return null;
        }
        return item.requires.find((r) => !ret.find((i1) => i1.name === r));
    };

    for (;pendings.length;) {
        const item = pendings.shift();

        const required = getRequired(item);
        if (!required) {
            ret.push(item);
            const w = waitings[item.name];
            if (w) {
                delete waitings[item.name];
                pendings.push(...w);
            }
        } else {
            addToListMap(waitings, required, item);
        }
    }
    if (!isEmpty(waitings)) {
        throw `Circular dependencies: ` + Object.keys(waitings);
    }
    return ret;
};

const validate = (list) => {
    for (const e of list) {
        const req = e.requires?.find((name) => !list.find((e) => e.name === name));
        if (req) {
            throw `Unknown required dependency [${req}] in [${e.name}]`;
        }
    }
    for (let i = 0; i < list.length; i++) {
        const e1 = list[i];
        for (let j = i+1; j < list.length; j++) {
            const e2 = list[j];
            if (e1.name != null && e1.name === e2.name) {
                throw `Duplicated name: ${e1.name}`;
            }
        }
    }

    return list.map((m) => !m.requiresOptional?.length ? (
        m
    ) : ({
        ...m,
        requires: [
            ...m.requires??[],
            ...m.requiresOptional.filter((name) => list.find((e) => e.name === name)),
        ],
    }));
};
